import HashtagPill from "./HashtagPill";

export default function OpportunityHashtagRow({ hashtags = [], selected = false, size = "sm" }) {
    if (hashtags.length === 0) return null;

    return (
        <div className="flex min-w-0 flex-wrap items-center gap-1.5 md:gap-2">
            {hashtags.map((tag, index) => (
                <HashtagPill key={`${tag}-${index}`} tag={tag} selected={selected} size={size} />
            ))}
        </div>
    );
}
